import { render } from "./TitledList.vue?vue&type=template&id=5bfc5234"
import script from "./TitledList.vue?vue&type=script&lang=js"
export * from "./TitledList.vue?vue&type=script&lang=js"

import "./TitledList.vue?vue&type=style&index=0&id=5bfc5234&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__